import config from "@/config"

//系统路由
const routes = [
	{
		name: "layout",
		path: "/",
		component: () => import(/* webpackChunkName: "layout" */ '@/layout'),
		redirect: config.DASHBOARD_URL || '/dashboard',
		meta: {
			title: "首页"
		}
	},
	{
		path: "/login",
		component: () => import(/* webpackChunkName: "login" */ '@/views/base/login'),
		// component: () => import(/* webpackChunkName: "login" */ '@/views/qyj/pages/login'),
		meta: {
			title: "登录"
		}
	},
	{
		path: "/user_register",
		component: () => import(/* webpackChunkName: "userRegister" */ '@/views/base/login/userRegister'),
		meta: {
			title: "注册"
		}
	},
	{
		path: "/generateLink",
		component: () => import(/* webpackChunkName: "userRegister" */ '@/views/base/login/generateLink'),
		meta: {
			title: "提交"
		}
	},
	{
		path: "/financialDiagnosis",
		component: () => import(/* webpackChunkName: "userRegister" */ '@/views/base/login/financialDiagnosis.vue'),
		meta: {
			title: "个人财务诊断书"
		}
	},
	{
		path: "/reset_password",
		component: () => import(/* webpackChunkName: "resetPassword" */ '@/views/base/login/resetPassword'),
		meta: {
			title: "重置密码"
		}
	},
	{
		path: "/download",
		component: () => import(/* webpackChunkName: "download" */ '@/views/download/foreground'),
		meta: {
			title: "下载"
		}
	},
	{
		path: "/downloadapp",
		component: () => import(/* webpackChunkName: "downloadapp" */ '@/views/download/foreground/downloadApp'),
		meta: {
			title: "下载app"
		}
	},

]

export default routes;
